import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';
import Image from 'tbk-components/src/components/Image';

import logoSm from '../../assets/logo-bus-sm.svg';
import logoMd from '../../assets/logo-bus-md.svg';
import logoLg from '../../assets/logo-bus-lg.svg';

const logos = {
	sm: logoSm,
	md: logoMd,
	lg: logoLg,
};
export interface SocialIcon {
	url: string;
	name: string;
}

export interface ISocialIconsProps extends IBaseElementProps {
	icons?: SocialIcon[];
	showLogo?: boolean;
	logoSize?: 'auto' | 'sm' | 'md' | 'lg';
	showFollowUs?: boolean;
}

/**
 * Social Icons
 * @block
 *
 */

const SocialIcons: React.FC<ISocialIconsProps> = ({
	className,
	classNames = [],
	icons = [],
	showLogo,
	logoSize = 'auto',
	showFollowUs,
}) => (
	<div className={className || cn('social-icons', ...classNames)}>
		<ul className="social-icons__wrapper">
			{showLogo && (
				<li>
					{logoSize !== 'auto' ? (
						<Image
							src={logos[logoSize]}
							width={170}
							height={64}
							alt="My Big Yellow Bus"
							className="logo"
						/>
					) : (
						<>
							<Image
								src={logoSm}
								width={170}
								height={64}
								alt="My Big Yellow Bus"
								className="logo d-md-none"
							/>
							<Image
								src={logoMd}
								width={170}
								height={64}
								alt="My Big Yellow Bus"
								className="logo d-none d-md-block d-lg-none"
							/>
							<Image
								src={logoLg}
								width={170}
								height={64}
								alt="My Big Yellow Bus"
								className="logo d-none d-lg-block"
							/>
						</>
					)}
				</li>
			)}
			{showFollowUs && (
				<li className="d-none d-md-block">
					<h3>Follow Us</h3>
				</li>
			)}
			{icons.length > 0 &&
				icons.map(({ name, url }) => (
					<li key={name}>
						<a
							href={url}
							target="_blank"
							aria-label={name}
							rel="noreferrer"
						>
							<Icon name={name.toLowerCase()} />
						</a>
					</li>
				))}
		</ul>
	</div>
);

export default SocialIcons;
